// Paginacion.jsx
import React, { useState, useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';
import { useNavigate } from "react-router-dom";

const Paginacion = ({ currentPage, totalPages }) => {
  const [paginaActual, setPaginaActual] = useState(currentPage);
  const navigate = useNavigate();
  const urlPadre = window.location.pathname;
  const url = new URL(window.location);
  const params = new URLSearchParams(url.search);
  const busqueda = params.get("busqueda") || '';

  useEffect(() => {
    navigate(`${urlPadre}?pagina=${paginaActual}&busqueda=${busqueda}`);
  }, [paginaActual, busqueda]);

  const handleChange = (event, value) => {
    setPaginaActual(value);
  };

  return (
    <EstiloPaginado>
      <Stack spacing={0}>
        <Pagination
          count={totalPages}
          color="warning"
          boundaryCount={1}
          page={paginaActual}
          onChange={handleChange}
          siblingCount={1}
        />
      </Stack>
    </EstiloPaginado>
  );
};

const EstiloPaginado = styled.div`
  margin-top: 5%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Paginacion;
